import ListProcesses from "@/views/service_provider/delivery/managing/ListProcesses.vue";
import ShowProcess from "@/views/service_provider/delivery/managing/ShowProcess.vue";
import ShowProcessDeliveryProducts from "@/components/views/service_provider/delivery/managing/show_process/DeliveryProducts.vue";
import ShowProcessOrders from "@/components/views/service_provider/delivery/managing/show_process/Orders.vue";
import ShowProcessDeliveries from "@/components/views/service_provider/delivery/managing/show_process/Deliveries.vue";
import ShowProcessDeliveryCollections from "@/components/views/service_provider/delivery/managing/show_process/DeliveryCollections.vue";
import ShowProcessDeliveryProcessProviders from "@/components/views/service_provider/delivery/managing/show_process/DeliveryProcessProviders.vue";
import NewOrder from "@/views/service_provider/delivery/managing/NewOrder.vue";
import EditOrder from "@/views/service_provider/delivery/managing/EditOrder.vue";
import ShowOrder from "@/views/service_provider/delivery/managing/ShowOrder.vue";
import ShowDelivery from "@/views/service_provider/delivery/managing/ShowDelivery.vue";
import ShowDeliveryCollection from "@/views/service_provider/delivery/managing/ShowDeliveryCollection.vue";
import NewDeliveryProcessProvider from "@/views/service_provider/delivery/managing/NewDeliveryProcessProvider.vue";
import EditDeliveryProcessProvider from "@/views/service_provider/delivery/managing/EditDeliveryProcessProvider.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "sp",
  role: "delivery",
  permission: "managing",
});

export default [
  {
    path: "/sp/:service_provider_id/delivery/managing/list_processes",
    name: routeName(""),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/sp/:service_provider_id/delivery/managing/show_process/:delivery_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    redirect: { name: routeName("show_process_orders") },
    props: true,
    meta: META,
    children: [
      {
        path: "delivery_products",
        name: routeName("show_process_delivery_products"),
        component: ShowProcessDeliveryProducts,
        props: true,
        meta: META,
      },
      {
        path: "delivery_collections",
        name: routeName("show_process_delivery_collections"),
        component: ShowProcessDeliveryCollections,
        props: true,
        meta: META,
      },
      {
        path: "orders",
        name: routeName("show_process_orders"),
        component: ShowProcessOrders,
        props: true,
        meta: META,
      },
      {
        path: "deliveries",
        name: routeName("show_process_deliveries"),
        component: ShowProcessDeliveries,
        props: true,
        meta: META,
      },
      {
        path: "delivery_process_providers",
        name: routeName("show_process_delivery_process_providers"),
        component: ShowProcessDeliveryProcessProviders,
        props: true,
        meta: META,
      },
    ]
  },
  {
    path: "/sp/:service_provider_id/delivery/managing/:delivery_process_id/new_order",
    name: routeName("new_order"),
    component: NewOrder,
    props: true,
    meta: META
  },
  {
    path: "/sp/:service_provider_id/delivery/managing/:delivery_process_id/show_order/:id",
    name: routeName("show_order"),
    component: ShowOrder,
    props: true,
    meta: META
  },
  {
    path: "/sp/:service_provider_id/delivery/managing/:delivery_process_id/edit_order/:id",
    name: routeName("edit_order"),
    component: EditOrder,
    props: true,
    meta: META
  },
  {
    path: "/sp/:service_provider_id/delivery/managing/:delivery_process_id/show_delivery/:id",
    name: routeName("show_delivery"),
    component: ShowDelivery,
    props: true,
    meta: META
  },
  {
    path: "/sp/:service_provider_id/delivery/managing/:delivery_process_id/show_delivery_collection/:id",
    name: routeName("show_delivery_collection"),
    component: ShowDeliveryCollection,
    props: true,
    meta: META
  },
  {
    path: "/sp/:service_provider_id/delivery/managing/:delivery_process_id/new_delivery_process_provider",
    name: routeName("new_delivery_process_provider"),
    component: NewDeliveryProcessProvider,
    props: true,
    meta: META
  },
  {
    path: "/sp/:service_provider_id/delivery/managing/:delivery_process_id/edit_delivery_process_provider/:id",
    name: routeName("edit_delivery_process_provider"),
    component: EditDeliveryProcessProvider,
    props: true,
    meta: META
  },
]
